import { render, staticRenderFns } from "./SignIn2.vue?vue&type=template&id=2449dc33&scoped=true&lang=pug&"
import script from "./SignIn2.vue?vue&type=script&lang=ts&"
export * from "./SignIn2.vue?vue&type=script&lang=ts&"
import style0 from "./SignIn2.vue?vue&type=style&index=0&id=2449dc33&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449dc33",
  null
  
)

export default component.exports